import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import TitleAndDescription from 'app/scripts/components/common/title-and-description';
import { fetchModerationFiltersConfigs } from './moderation-filters/moderationFilterActions';
import { ModerationFilters } from './moderation-filters/ModerationFilters';

interface Props {
  spotId: string;
  isSuperAdmin: boolean;
  isAIModerationAssistanceEnabled: boolean;
  handleAIModerationAssistance: (isEnabled: boolean) => void;
}

export const ModerationFiltersSettings: React.FC<Props> = ({
  spotId,
  isSuperAdmin,
  isAIModerationAssistanceEnabled,
  handleAIModerationAssistance
}) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchModerationFiltersConfigs(spotId));
  }, [dispatch, spotId]);

  return (
    <div className={'perspective-settings-container'}>
      <TitleAndDescription
        titleFont={15}
        title="Automated Moderation Filters"
        description={
          <p>
            Use automated filters to detect toxic comments and make moderation decisions more
            efficiently.
          </p>
        }
      />
      <ModerationFilters
        isSuperAdmin={isSuperAdmin}
        spotId={spotId}
        isAIModerationAssistanceEnabled={isAIModerationAssistanceEnabled}
        handleAIModerationAssistance={handleAIModerationAssistance}
      />
    </div>
  );
};
